/* eslint-disable prettier/prettier */
/* eslint-disable no-shadow */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-template */
/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import useMediaQuery from "@mui/material/useMediaQuery";
import { styled, useTheme } from "@mui/material/styles";
import React, {
  useEffect,
  useMemo,
  useState,
  useRef,
  useCallback,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { css } from "aphrodite";
import Logo from "../../assets/svg/Logo";
import LogoutIcon from "../../assets/svg/sidebar/Logout";
import useUserConfig from "../../hooks/useUserConfig";
import {
  SET_RESET_APPOINTMENT_STATE,
  SET_RESET_GOHONZON_STATE,
} from "../../redux/actionTypes/dashboard";
import { selectUserRole } from "../../redux/selectors/user";
import Header from "../Header";
import NavItem from "./NavItem";
import Styles from "./styles";
import { getDrawerItems } from "./utils";
import ColorBar from "../ui/Colorbar";
import {
  CLOSE_DRAWER_EVENT_NAME,
  OPEN_DRAWER_EVENT_NAME,
  OPEN_SAVE_ALERT_EVENT_NAME,
  TABLE_ROUTES,
} from "../../contants";
import Heading from "../Heading";
import Style from "./NewStyles";
import ForceLogout from "../../services/api/ForceLogout";

const DRAWER_WIDTH = 230;
const RAIL_WIDTH = 72;

const openedMixin = (theme) => ({
  overflowY: "hidden",
  width: "16.5rem",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  background: "#0b2c8a",
  position: "relative",
});

const openedMixinMobile = (theme) => ({
  overflowY: "hidden",
  width: "12.6rem",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  background: "#0b2c8a",
  position: "relative",
});

const closedMixin = (theme) => ({
  overflowY: "hidden",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  width: `${RAIL_WIDTH}px`,
  background: "#0B2C8A",
  minWidth: `${RAIL_WIDTH}px`,
  position: "relative",
});

const closedMixinMobile = (theme) => ({
  overflowY: "hidden",
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  width: "0px",
  background: "#0b2c8a",
  minWidth: "0px",
  position: "fixed",
});

const DrawerHeader = styled("div")(({ theme }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return {
    display: "flex",
    width: "100%",
    padding: isMobile ? theme.spacing(0, 1, 0, 7) : theme.spacing(0, 1, 0, 12),
    alignItems: "center",
    border: "none",
    ...theme.mixins.toolbar,
    justifyContent: "space-between",
  };
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return {
    minWidth: isMobile ? "0px" : DRAWER_WIDTH,
    width: "19%",
    flexShrink: 0,
    whiteSpace: "normal",
    boxSizing: "border-box",
    height: "100vh",
    overflowY: "hidden",
    ...(open && {
      ...(isMobile ? openedMixinMobile(theme) : openedMixin(theme)),
      "& .MuiDrawer-paper": isMobile
        ? openedMixinMobile(theme)
        : openedMixin(theme),
    }),
    ...(!open && {
      ...(isMobile ? closedMixinMobile(theme) : closedMixin(theme)),
      "& .MuiDrawer-paper": isMobile
        ? closedMixinMobile(theme)
        : closedMixin(theme),
    }),
  };
});

const HoverMenu = ({
  item,
  position,
  onClose,
  level = 0,
  triggerRect,
  onMouseEnterMenu,
  onMouseLeaveMenu,
}) => {
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const [adjustedPosition, setAdjustedPosition] = useState(position);
  const [expandedItems, setExpandedItems] = useState({});
  const [direction, setDirection] = useState("down");
  const [submenuMaxHeight, setSubmenuMaxHeight] = useState(0);

  useEffect(() => {
    if (!menuRef.current || !position || !triggerRect) return undefined;

    const updateMenuPosition = () => {
      const viewportPadding = 12;
      const viewportHeight = window.innerHeight;

      const headerEl = menuRef.current.querySelector(".hover-menu-header");
      const headerHeight = headerEl ? headerEl.offsetHeight : 58;

      const fullMenuHeight = menuRef.current.scrollHeight;

      let top = triggerRect.top;
      const maxTop = viewportHeight - fullMenuHeight - viewportPadding;

      if (top > maxTop) {
        top = maxTop;
      }

      if (top < viewportPadding) {
        top = viewportPadding;
      }

      const availableHeight = viewportHeight - top - viewportPadding;
      const bodyHeight = Math.max(180, availableHeight - headerHeight);

      setAdjustedPosition({
        left: triggerRect.right,
        top,
      });

      setSubmenuMaxHeight(bodyHeight);
    };

    const raf = requestAnimationFrame(updateMenuPosition);
    window.addEventListener("resize", updateMenuPosition);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", updateMenuPosition);
    };
  }, [position, triggerRect, item, expandedItems]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);

  if (!item || !position) return null;

  const handleNavigation = (targetItem) => {
    if (targetItem.path) {
      navigate(targetItem.path);
    } else if (targetItem.onClick) {
      targetItem.onClick();
    }
    onClose();
  };

  const toggleNestedMenu = (itemKey) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemKey]: !prev[itemKey],
    }));
  };

  const submenuItems = item.members || [];
  const hasSubmenu = submenuItems.length > 0;

  const renderNestedItems = (items, parentKey = "", depth = 0) => {
    return items.map((subItem, index) => {
      const itemKey = `${parentKey}-${subItem.key || subItem.title || index}`;
      const subHasSubmenu = subItem.members && subItem.members.length > 0;
      const isExpanded = expandedItems[itemKey];

      return (
        <React.Fragment key={itemKey}>
          <div
            onClick={() => {
              if (subHasSubmenu) {
                toggleNestedMenu(itemKey);
              } else {
                handleNavigation(subItem);
              }
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(255,255,255,0.12)";
              e.currentTarget.style.borderLeft = "3px solid #F7D20B";
              e.currentTarget.style.color = "#FFFFFF";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.borderLeft = "3px solid transparent";
              e.currentTarget.style.color = "rgba(255,255,255,0.9)";
            }}
            style={{
              padding: `12px 18px 12px ${45 + depth * 20}px`,
              cursor: "pointer",
              fontSize: "14px",
              color: "rgba(255,255,255,0.9)",
              transition: "all 0.2s ease",
              borderLeft: "3px solid transparent",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "8px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              {subItem.icon && (
                <span
                  className="nested-icon"
                  style={{
                    fontSize: "13px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {subItem.icon}
                </span>
              )}
              <span>{subItem.title}</span>
            </div>
            {subHasSubmenu && (
              <span
                style={{
                  fontSize: "10px",
                  opacity: 0.7,
                  transition: "transform 0.2s ease",
                  transform: isExpanded ? "rotate(90deg)" : "rotate(0deg)",
                }}
              >
                ▶
              </span>
            )}
          </div>

          {subHasSubmenu && isExpanded && (
            <div
              className="nested-items-scrollable"
              style={{
                background: "rgba(0,0,0,0.15)",
                borderLeft: "2px solid rgba(247,210,11,0.3)",
                maxHeight: "250px",
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              {renderNestedItems(subItem.members, itemKey, depth + 1)}
            </div>
          )}
        </React.Fragment>
      );
    });
  };

  return (
    <div
      ref={menuRef}
      className="hover-menu"
      onMouseEnter={onMouseEnterMenu}
      onMouseLeave={onMouseLeaveMenu}
      style={{
        position: "fixed",
        left: adjustedPosition?.left || triggerRect?.right || position.left,
        top: adjustedPosition?.top || position.top,
        background: "#1a237e",
        color: "white",
        borderRadius: "8px",
        boxShadow: `0 ${level * 2 + 4}px ${level * 4 + 20}px rgba(0,0,0,${
          0.25 + level * 0.1
        })`,
        zIndex: 9999 + level,
        minWidth: "260px",
        maxWidth: "320px",
        border: "1px solid rgba(255,255,255,0.1)",
        overflow: "hidden",
        maxHeight: "80vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: direction === "up" ? "flex-end" : "flex-start",
      }}
    >
      <div
        onClick={() => !hasSubmenu && handleNavigation(item)}
        style={{
          padding: "14px 18px",
          cursor: hasSubmenu ? "default" : "pointer",
          borderBottom: hasSubmenu ? "1px solid rgba(255,255,255,0.1)" : "none",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          justifyContent: "space-between",
          transition: "background 0.2s ease",
          background: hasSubmenu ? "rgba(255,255,255,0.08)" : "transparent",
        }}
        onMouseEnter={(e) => {
          if (!hasSubmenu) {
            e.currentTarget.style.background = "rgba(255,255,255,0.15)";
          }
        }}
        onMouseLeave={(e) => {
          if (!hasSubmenu) {
            e.currentTarget.style.background = "transparent";
          }
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <span
            style={{ fontSize: "16px", display: "flex", alignItems: "center" }}
          >
            {item.icon}
          </span>
          <span style={{ fontSize: "15px", fontWeight: "600" }}>
            {item.title}
          </span>
        </div>
        {hasSubmenu && (
          <span style={{ fontSize: "10px", opacity: 0.8 }}>▼</span>
        )}
      </div>

      {hasSubmenu && (
        <div
          className="submenu-scrollable"
          style={{
            background: "rgba(0,0,0,0.2)",
            maxHeight: submenuMaxHeight,
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {renderNestedItems(submenuItems)}
        </div>
      )}
    </div>
  );
};

export default function Layout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [hoverPosition, setHoverPosition] = useState(null);
  const [triggerRect, setTriggerRect] = useState(null);
  const hasPermission = useUserConfig();
  const userRole = useSelector(selectUserRole);
  const drawerItems = getDrawerItems(hasPermission, userRole);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const location = useLocation();
  const hoverTimeoutRef = useRef(null);
  const isHoveringRef = useRef(false);
  const drawerRef = useRef(null);

  const isMenuItemActive = useCallback((item, currentPath) => {
    if (!item || !currentPath) return false;
    if (item.path && currentPath.includes(item.path)) return true;
    if (item.path && currentPath.startsWith(item.path)) return true;

    const checkMembers = (members) => {
      if (!members) return false;
      return members.some((member) => {
        if (member.path && currentPath.includes(member.path)) return true;
        if (member.path && currentPath.startsWith(member.path)) return true;
        return checkMembers(member.members);
      });
    };
    return checkMembers(item.members);
  }, []);

  const handleDrawerToggle = () => {
    if (!open) {
      document.dispatchEvent(new Event(OPEN_SAVE_ALERT_EVENT_NAME));
    }
    setOpen(!open);
  };

  const clearHoverTimeout = useCallback(() => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
  }, []);

  const handleIconHover = useCallback(
    (item, event) => {
      clearHoverTimeout();
      isHoveringRef.current = true;

      const rect = event.currentTarget.getBoundingClientRect();
      setHoverPosition({
        left: rect.left,
        top: rect.top,
        bottom: rect.bottom,
        right: rect.right,
      });
      setTriggerRect(rect);
      setHoveredItem(item);
    },
    [clearHoverTimeout]
  );

  const handleIconLeave = useCallback(() => {
    isHoveringRef.current = false;
    clearHoverTimeout();

    hoverTimeoutRef.current = setTimeout(() => {
      if (!isHoveringRef.current) {
        setHoveredItem(null);
        setHoverPosition(null);
        setTriggerRect(null);
      }
    }, 150);
  }, [clearHoverTimeout]);

  const handleMenuMouseEnter = useCallback(() => {
    clearHoverTimeout();
    isHoveringRef.current = true;
  }, [clearHoverTimeout]);

  const handleMenuMouseLeave = useCallback(() => {
    isHoveringRef.current = false;
    clearHoverTimeout();

    hoverTimeoutRef.current = setTimeout(() => {
      if (!isHoveringRef.current) {
        setHoveredItem(null);
        setHoverPosition(null);
        setTriggerRect(null);
      }
    }, 150);
  }, [clearHoverTimeout]);

  const handleMenuClose = useCallback(() => {
    isHoveringRef.current = false;
    clearHoverTimeout();
    setHoveredItem(null);
    setHoverPosition(null);
    setTriggerRect(null);
  }, [clearHoverTimeout]);

  const handleRailIconClick = useCallback(
    (item) => {
      setOpen(true);
      const hasAnySubmenu = (menuItem) => {
        if (!menuItem.members || menuItem.members.length === 0) return false;
        return true;
      };

      if (!hasAnySubmenu(item)) {
        if (item.path) {
          setTimeout(() => {
            navigate(item.path);
          }, 100);
        } else if (item.onClick) {
          item.onClick();
        }
      }
      handleMenuClose();
    },
    [navigate, handleMenuClose]
  );

  const handleClickOutside = useCallback((event) => {
    if (drawerRef.current && !drawerRef.current.contains(event.target)) {
      setOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  //  const logout = async () => {
  //   const loginId = localStorage.getItem("loginId");

  //   if (!loginId) return;

  //   try {
  //     console.log("⏳ Calling backend logout API...");

  //     const response = await ForceLogout.userLogout(loginId);

  //     console.log("🟢 Backend logoutActiveStatus updated successfully:", response);

  //     // Now local logout
  //     localStorage.removeItem("authToken");
  //     localStorage.removeItem("loginId");
  //     localStorage.removeItem("memberId");
  //     localStorage.removeItem("areaId");
  //     localStorage.removeItem("positionRole");

  //     dispatch({ type: SET_RESET_GOHONZON_STATE });
  //     dispatch({ type: SET_RESET_APPOINTMENT_STATE });
  //     dispatch({ type: "LOGOUT" });

  //   } catch (error) {
  //     console.error("🔥 Error calling logout API:", error);
  //    // return; // Do NOT logout locally
  //   }
  // };
  const logout = async () => {
    const loginId = localStorage.getItem("loginId");

    if (loginId) {
      try {
        // console.log("📡 Calling backend logout API...");

        const response = await ForceLogout.userLogout(loginId);

        // console.log("🟢 API Response:", response);

        if (response?.status === 200 || response?.data?.code === 200) {
          console.log("🟢 Backend logoutActiveStatus updated successfully");
        } else {
          console.warn(
            "⚠️ API did not return success, but continuing logout..."
          );
        }
      } catch (error) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("loginId");
        localStorage.removeItem("memberId");
        localStorage.removeItem("areaId");
        localStorage.removeItem("clusterId");
        localStorage.removeItem("positionRole");
        localStorage.removeItem("LoginTime");
        localStorage.removeItem("rolePopupShown");

        dispatch({ type: SET_RESET_GOHONZON_STATE });
        dispatch({ type: SET_RESET_APPOINTMENT_STATE });
        dispatch({ type: "LOGOUT" });
        console.error("🔥 Logout API failed:", error);
        return; // ❌ Stop logout if backend update fail hota hai
      }
    }

    // 🔥 API success ke baad hi ye chalega
    localStorage.removeItem("authToken");
    localStorage.removeItem("loginId");
    localStorage.removeItem("memberId");
    localStorage.removeItem("areaId");
    localStorage.removeItem("clusterId");
    localStorage.removeItem("positionRole");
    localStorage.removeItem("LoginTime");
    localStorage.removeItem("rolePopupShown");

    dispatch({ type: SET_RESET_GOHONZON_STATE });
    dispatch({ type: SET_RESET_APPOINTMENT_STATE });
    dispatch({ type: "LOGOUT" });

    console.log("✅ Frontend logout completed!");
  };

  const onLogoClick = () => {
    navigate("/");
  };

  const isTableRoute = useMemo(
    () => !!TABLE_ROUTES.find((route) => pathname.includes(route)),
    [pathname]
  );

  useEffect(() => {
    document.addEventListener(CLOSE_DRAWER_EVENT_NAME, () => setOpen(false));
    document.addEventListener(OPEN_DRAWER_EVENT_NAME, () => setOpen(true));
    return () => {
      document.removeEventListener(CLOSE_DRAWER_EVENT_NAME, () =>
        setOpen(false)
      );
      document.removeEventListener(OPEN_DRAWER_EVENT_NAME, () => setOpen(true));
    };
  }, []);

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
    .blue-drawer-content {
      color: #FFFFFF;
      background: #1a237e;
    }
    .blue-drawer-content * {
      color: #FFFFFF !important;
    }
    .blue-drawer-content svg,
    .blue-drawer-content svg *,
    .blue-drawer-content path,
    .blue-drawer-content g {
      fill: #FFFFFF !important;
    }
    
    .blue-drawer-content .MuiListItemButton-root {
      position: relative;
      border-radius: 0px !important;
      margin: 0px !important;
      padding: 12px 18px !important;
      border-left: 3px solid transparent;
      transition: all 0.2s ease;
    }
    
    .blue-drawer-content .MuiListItemButton-root:hover {
      background-color: rgba(255, 255, 255, 0.12) !important;
      border-left: 3px solid #F7D20B !important;
    }
    
    .blue-drawer-content .MuiListItemButton-root.Mui-selected {
      background-color: rgba(255, 255, 255, 0.08) !important;
      border-left: 3px solid #F7D20B !important;
    }
    
    .blue-drawer-content .MuiCollapse-root.MuiCollapse-entered {
      border-left: 2px solid rgba(247, 210, 11, 0.3) !important;
      margin-left: 0px;
      background: rgba(0,0,0,0.15);
    }
    
    .blue-drawer-content .MuiCollapse-root .MuiListItemButton-root {
      padding-left: 45px !important;
    }
    
    .blue-drawer-content .MuiCollapse-root .MuiCollapse-root .MuiListItemButton-root {
      padding-left: 65px !important;
    }
    
    .blue-drawer-content::-webkit-scrollbar {
      width: 5px;
    }
    .blue-drawer-content::-webkit-scrollbar-track {
      background: rgba(255,255,255,0.05);
      border-radius: 2px;
    }
    .blue-drawer-content::-webkit-scrollbar-thumb {
      background: rgba(255,255,255,0.3);
      border-radius: 2px;
    }
    .blue-drawer-content::-webkit-scrollbar-thumb:hover {
      background: rgba(255,255,255,0.5);
    }
    
    .rail-icon {
      transition: all 0.2s ease;
      position: relative;
    }
    .rail-icon:hover {
      background-color: rgba(255,255,255,0.1) !important;
      transform: scale(1.05);
    }
    .rail-icon.active {
      background-color: rgba(255,255,255,0.2) !important;
      border-left: 3px solid #F7D20B !important;
    }
    .rail-icon svg,
    .rail-icon svg *,
    .rail-icon path,
    .rail-icon g,
    .rail-icon circle,
    .rail-icon rect {
      fill: #FFFFFF !important;
    }
    .nested-icon svg,
    .nested-icon svg *,
    .nested-icon path,
    .nested-icon g {
      fill: #FFFFFF !important;
    }
    .hover-menu {
      animation: slideInFromLeft 0.2s ease-out;
    }
    .submenu-scrollable::-webkit-scrollbar {
      width: 5px;
    }
    .submenu-scrollable::-webkit-scrollbar-track {
      background: rgba(255,255,255,0.05);
      border-radius: 2px;
    }
    .submenu-scrollable::-webkit-scrollbar-thumb {
      background: rgba(255,255,255,0.3);
      border-radius: 2px;
    }
    .submenu-scrollable::-webkit-scrollbar-thumb:hover {
      background: rgba(255,255,255,0.5);
    }
    .nested-items-scrollable::-webkit-scrollbar {
      width: 4px;
    }
    .nested-items-scrollable::-webkit-scrollbar-track {
      background: rgba(255,255,255,0.03);
      border-radius: 2px;
    }
    .nested-items-scrollable::-webkit-scrollbar-thumb {
      background: rgba(247,210,11,0.4);
      border-radius: 2px;
    }
    .nested-items-scrollable::-webkit-scrollbar-thumb:hover {
      background: rgba(247,210,11,0.6);
    }
    .hover-menu::-webkit-scrollbar {
      width: 4px;
    }
    .hover-menu::-webkit-scrollbar-track {
      background: rgba(255,255,255,0.1);
      border-radius: 2px;
    }
    .hover-menu::-webkit-scrollbar-thumb {
      background: rgba(255,255,255,0.3);
      border-radius: 2px;
    }
    .hover-menu::-webkit-scrollbar-thumb:hover {
      background: rgba(255,255,255,0.5);
    }
    @keyframes slideInFromLeft {
      from {
        opacity: 0;
        transform: translateX(-10px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }
  `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  const RailIcon = ({ item, isActive }) => (
    <div
      className={`rail-icon ${isActive ? "active" : ""}`}
      onClick={() => handleRailIconClick(item)}
      onMouseEnter={(e) => handleIconHover(item, e)}
      onMouseLeave={handleIconLeave}
      style={{
        width: 48,
        height: 48,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 8,
        cursor: "pointer",
        background: isActive ? "rgba(255,255,255,0.2)" : "transparent",
        position: "relative",
        borderLeft: isActive ? "3px solid #F7D20B" : "3px solid transparent",
        transition: "all 0.2s ease",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          filter: "brightness(0) invert(1)",
        }}
      >
        {item.icon}
      </div>
    </div>
  );

  useEffect(() => {
    return () => {
      clearHoverTimeout();
    };
  }, [clearHoverTimeout]);

  return (
    <Box sx={Styles.boxPrimary}>
      <CssBaseline />
      <Drawer
        variant="permanent"
        open={open}
        ref={isMobile ? drawerRef : null}
        sx={{
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            border: "none",
          },
        }}
      >
        {!isMobile && !open ? (
          <>
            <div
              style={{
                height: "72px",
                background: "#F7D20B",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0px 2px 16px rgba(0, 0, 0, 0.1)",
                cursor: "pointer",
              }}
              onClick={handleDrawerToggle}
            >
              <div
                style={{ color: "#0B2C8A", fontSize: 24, fontWeight: "bold" }}
              >
                ☰
              </div>
            </div>
            <div
              style={{
                flex: 1,
                background: "#1a237e",
                padding: "16px 0",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 12,
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              {drawerItems?.map((item) => (
                <RailIcon
                  key={item.key}
                  item={item}
                  isActive={isMenuItemActive(item, pathname)}
                />
              ))}
              <RailIcon
                item={{
                  icon: <LogoutIcon />,
                  title: "Logout",
                  onClick: logout,
                  key: "logout",
                }}
                isActive={false}
              />
            </div>
          </>
        ) : (
          <>
            <DrawerHeader
              style={{
                height: "83px",
                background: "#f7d20b",
                position: "relative",
                zIndex: 2,
                boxShadow: "0px 1px 4px rgba(255, 255, 255, 0.3)",
              }}
            >
              <div
                style={{
                  width: "65%",
                  height: "85%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Logo
                  onClick={onLogoClick}
                  style={{
                    cursor: "pointer",
                    width: isMobile ? "70px" : "70%",
                  }}
                />
              </div>
            </DrawerHeader>
            <div
              className="blue-drawer-content"
              style={{
                ...Styles.container,
                background: "#1a237e",
                minHeight: "calc(100vh - 83px)",
              }}
            >
              <div
                style={{
                  ...(isMobile
                    ? Styles.listContainerMobile
                    : Styles.listContainer),
                  padding: "8px 0",
                }}
              >
                {drawerItems?.map((item) => (
                  <NavItem key={item.key} {...item} />
                ))}
                <NavItem
                  title="Logout"
                  icon={<LogoutIcon />}
                  onClick={logout}
                  path="/logout"
                  isParent
                  hideArrow
                />
              </div>
            </div>
          </>
        )}
      </Drawer>

      {!isMobile && !open && hoveredItem && (
        <HoverMenu
          item={hoveredItem}
          position={hoverPosition}
          triggerRect={triggerRect}
          onClose={handleMenuClose}
          onMouseEnterMenu={handleMenuMouseEnter}
          onMouseLeaveMenu={handleMenuMouseLeave}
          level={0}
        />
      )}

      <Box
        component="main"
        className={css(isMobile ? Style.mainMobile : Style.main)}
      >
        <Box style={Styles.boxDrawerStickyHeader}>
          <Header open={open} handleDrawerToggle={handleDrawerToggle} />
          <ColorBar />
        </Box>
        <Box
          style={{
            ...Styles.wrapper,
            flex: 1,
            overflowY: "hidden",
            overflowX: "hidden",
          }}
        >
          {isMobile && location.pathname !== "/" && <Heading />}
          <Box
            className={css(
              !isTableRoute ? Style.outletContainer : Style.outletContainertable
            )}
            style={{
              height: "100%",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
